import * as AuthActions from '../constants/authTypes';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { getHubAction } from '../actions/utils';
import AuthManager from '../services/AuthManager';


const GENERIC_STATE = {
  data: {},
  error: null,
  fetching: false,
  success: false,
};

const initialState = {
  user: null,
  hubUser: { ...GENERIC_STATE },
  otpData: { ...GENERIC_STATE },
  passwordUpdate: { ...GENERIC_STATE },
  User: { ...GENERIC_STATE },
  emailLink: { ...GENERIC_STATE },
};

export function session(state = initialState, action) {
  switch (action.type) {
    case AuthActions.ACTION_CHECK_SESSION:
    case AuthActions.UPDATE_MERCHANT_DETAILS_SUCCESS:
      return { ...state, user: action.payload };
    case getHubAction(AuthActions.CREATE_USER_INITIATED):
      return {
        ...state,
        hubUser: {
          data: {},
          fetching: true,
          error: null,
          success: false,
        },
      };
    case getHubAction(AuthActions.FETCH_USER_INITIATED):
      return {
        ...state,
        User: {
          data: {},
          fetching: true,
          error: null,
          success: false,
        },
      };
    case getHubAction(AuthActions.FETCH_USER_SUCCESS):
      return {
        ...state,
        User: {
          data: action.payload,
          fetching: false,
          error: null,
          success: true,
        },
      };
    case getHubAction(AuthActions.FETCH_USER_FAILURE):
      return {
        ...state,
        User: {
          ...state.hubUser,
          fetching: false,
          error: action.payload,
          success: false,
        },
      };
    case getHubAction(AuthActions.FETCH_USER_RESET):
      return {
        ...state,
        User: { ...GENERIC_STATE },
      };
    case getHubAction(AuthActions.CREATE_USER_SUCCESS):
      return {
        ...state,
        hubUser: {
          data: action.payload,
          fetching: false,
          error: null,
          success: true,
        },
      };
    case getHubAction(AuthActions.CREATE_USER_FAILURE):
      return {
        ...state,
        hubUser: {
          ...state.hubUser,
          fetching: false,
          error: action.payload,
          success: false,
        },
      };
    case getHubAction(AuthActions.SEND_OTP_INITIATED):
      return {
        ...state,
        otpData: {
          ...state.otpData,
          fetching: false,
          error: null,
          success: false,
        },
      };
    case getHubAction(AuthActions.SEND_OTP_FAILURE):
      return {
        ...state,
        otpData: {
          ...state.otpData,
          fetching: false,
          error: action.payload,
          success: false,
        },
      };
    case getHubAction(AuthActions.SEND_VERIFY_LINK_INITIATED):
      return {
        ...state,
        emailLink: {
          ...state.emailLink,
          fetching: false,
          error: null,
          success: false,
        },
      };
    case getHubAction(AuthActions.SEND_VERIFY_LINK_FAILURE):
      return {
        ...state,
        emailLink: {
          ...state.emailLink,
          fetching: false,
          error: action.payload,
          success: false,
        },
      };
    case getHubAction(AuthActions.VERIFY_OTP_RESET):
      return {
        ...state,
        otpData: { ...GENERIC_STATE },
      };
    case getHubAction(AuthActions.VERIFY_OTP_INITIATED):
      return {
        ...state,
        otpData: {
          data: {},
          fetching: true,
          error: null,
          success: false,
        },
      };
    case getHubAction(AuthActions.VERIFY_OTP_SUCCESS):
      const nextOptState = action.payload || state.otpData.data;
      if (nextOptState == action.payload) {
        AuthManager.persistFullToken(action.payload)
      }
      return {
        ...state,
        otpData: {
          data: nextOptState,
          fetching: false,
          error: null,
          success: true,
        },
      };
    case getHubAction(AuthActions.VERIFY_OTP_FAILURE):
      return {
        ...state,
        otpData: {
          ...state.otpData,
          fetching: false,
          error: action.payload,
          success: false,
        },
      };
    case getHubAction(AuthActions.UPDATE_PASSWORD_INITIATED):
      return {
        ...state,
        passwordUpdate: {
          success: false,
          fetching: true,
          error: null,
        },
      };
    case getHubAction(AuthActions.UPDATE_PASSWORD_SUCCESS):
      return {
        ...state,
        passwordUpdate: {
          success: true,
          fetching: false,
          error: null,
        },
      };
    case getHubAction(AuthActions.UPDATE_PASSWORD_FAILURE):
      return {
        ...state,
        passwordUpdate: {
          success: false,
          fetching: false,
          error: action.payload,
        },
      };
    case getHubAction(AuthActions.CLEAR_USER):
      return {
        ...state,
        User: {
          data: {},
          fetching: false,
          error: null,
          success: true,
        },
      };
    case getHubAction(AuthActions.FETCH_OR_CREATE_PLATFORM_USER_SUCCESS):
      const userData = action.payload;
      AuthManager.persistUserIdToLocalStorage(userData.uuid);
      return state;
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  session,
  form: formReducer,
});

export default rootReducer;
